import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";

export interface ILabelScope extends ng.IScope {
    invalid: boolean;
    icon: string;
    image: string;
    imageWhenSelected: string;
    selected: boolean;

}

@NgComponent({
    token: Token.KbLabel
})
export class KbLabel extends Directive {
    constructor() {
        super();

        this.replace = true;
        this.template = Dirs.component("kb-label");
        this.restrict = "E";
        this.scope = {
            invalid: "=?",
            icon: "@",
            image: "@",
            imageWhenSelected: "@",
            selected: "=?",
            backgroundColor: "=?",
            textColor: "=?"
        };
        this.transclude = true;

        this.link = (scope: ILabelScope, element, atts: any) => {
            
        };
    }
}
